module.exports = __webpack_public_path__ + "img/avatar.9acd84c8.png";